import http from "./http";
import api from "./api";
import moment from "moment";
import '@/antdCommon.scss';
import commonIcon from "@/utils/iconsFn"
import { useCommonStore } from '@/store';
import { Modal, Button, Input, Tooltip, DatePicker, Select, Form, InputNumber } from "antd";
import { ExclamationCircleOutlined, } from "@ant-design/icons";

const typeUrlMatch = {
  'util_payment': api.UploadFilePayment,
  'util_payment_add': api.UploadFilePayment,
  'util': api.UtilPaymentUpload,
  'businessLicense': api.businessLicenseMakePaymentUpload,
  // VendorMWorker模块
  'w9': api.getVendorUpload,
  'insurance_certificate': api.getVendorUpload,
  'contracts': api.getVendorUpload,
  'pending_check': api.pendingCheckUpload,
}

const uploadFiles = async (data, config) => {
  const files = []; // 存储上传成功后的文件信息

  // 检查输入数据是否有效
  if (!Array.isArray(data) || !data.length) {
    console.error("No files to upload!");
    return files;
  }
  const formData = new FormData();
  data.forEach((item) => formData.append("files", item.originFileObj));
  formData.append("type", config?.type || "util_payment");
  if(config?.foreignId){
    formData.append("foreignId", config?.foreignId || null);
  }
  const url = typeUrlMatch[config?.type || 'util_payment']
  const response = await http.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (response.code === "1" && Array.isArray(response.data)) {
    const uploadedFiles = response.data.map((item, index) => ({
      ...item,
      customId: data[index]?.uid,
    }));
    // 将每个文件信息添加到 files 数组
    files.push(...uploadedFiles);
  } else {
    console.error("Unexpected response format:", response.data);
  }
  return files;
};

const uploadFilesNew = async (data, apiUrl) => {
  const files = []; // 存储上传成功后的文件信息

  // 检查输入数据是否有效
  if (!Array.isArray(data) || !data.length) {
    console.error("No files to upload!");
    return files;
  }
  const formData = new FormData();
  data.forEach((item) => formData.append("files", item.originFileObj));
  const response = await http.post(apiUrl, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (response.code === "1" && Array.isArray(response.data)) {
    const uploadedFiles = response.data.map((item, index) => ({
      ...item,
      name:  data[index].name,
      uid: data[index].uid,
      originFileObj: data[index]['originFileObj'],
      baseUrl: data[index]['baseUrl'],
    }));
    // 将每个文件信息添加到 files 数组
    files.push(...uploadedFiles);
  } else {
    modalFailedFn(response)
  }
  return files;
};

const amountToDollarFn = (text) => {
    if (!text && text != 0) return "-"; // 处理空值
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(text);
}

const inputAmountFormat = (amount, flag = false, allowNegative = true) => {
  let value = String(amount ?? '');
  if (!value) return '';

  // 特殊输入处理："-", "-.", ".", "0."
  if (/^-?$/.test(value)) return allowNegative ? value : '';
  if (/^-?\.$/.test(value)) return allowNegative ? value.replace('.', '0.') : '0.';
  if (/^\.$/.test(value)) return '0.';

  // 去掉无效字符
  value = allowNegative ? value.replace(/(?!^-)[^\d.]/g, '') : value.replace(/[^\d.]/g, '');

  // 判断负数
  let isNegative = allowNegative && value.startsWith('-');
  if (isNegative) value = value.slice(1);

  // 拆分整数和小数
  let [intPart, decPart] = value.split('.');

  // 负零处理
  // if (isNegative && Number(value) === 0) isNegative = false;
if (isNegative && /^0*\.?0*$/.test(value)) isNegative = false;
  // flag = true → 返回纯数字（可带负号）
  if (flag) return (isNegative ? '-' : '') + value;

  // 千分位处理
  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return (isNegative ? '-' : '') + (decPart !== undefined ? `${intPart}.${decPart.slice(0, 2)}` : intPart);
};

const formInputNumberDoc = ({
  name = 'amount',
  label = 'Amount',
  form,
  disabled = false,
  allowNegative = false,
  onChangeFn,
  isNoRequired = false,
  validator,
  onBlurFn,
  suffix = null,
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={[
        { required: !isNoRequired, message: `${label} is required!`},
        {
          validator: validator || ((_, value, callback) => {
            if(value === 0){
              callback('Please enter an integer greater than 0!')
            } else {
              callback()
            }
          }), 
        },
      ]}
    >
      <InputNumber
        disabled={disabled}
        style={{ width: '100%' }}
        controls={false}
        prefix="$"
        suffix={suffix}
        placeholder={`Enter ${label}`}
        formatter={(value) => {
          if (value === undefined || value === null) return '';
          return inputAmountFormat(value, false, allowNegative);
        }}
        parser={(value) => {
          // 去掉 $ 和逗号
          return inputAmountFormat(value, true, allowNegative);
        }}
        onChange={(value) => {
          form.setFieldsValue({ [name]: value });
          form.validateFields([name]);
          if(typeof onChangeFn === 'function'){
            onChangeFn();
          }
        }}
        onBlur={() => {
          if(typeof onBlurFn === 'function'){
            onBlurFn();
          }
        }}
      />
    </Form.Item>
  )
}
const formInputNumberOptionalDoc = ({
  name = 'amount',
  label = 'Amount',
  form,
  disabled = false,
  allowNegative = false,
  onChangeFn,
  isNoRequired = false,
  validator,
  onBlurFn,
  suffix = null,
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={[
        { required: !isNoRequired, message: `${label} is required!`},
        {
          validator: validator || ((_, value, callback) => {
            // 不填金额金额时候跳过校验，非必填
            if (value === undefined || value === null || value === "") {
                return Promise.resolve();
              }
            if(value === 0){
              callback('Please enter an integer greater than 0!')
            } else {
              callback()
            }
          }), 
        },
      ]}
    >
      <InputNumber
        disabled={disabled}
        style={{ width: '100%' }}
        controls={false}
        prefix="$"
        suffix={suffix}
        placeholder={`Enter ${label}`}
        formatter={(value) => {
          if (value === undefined || value === null) return '';
          return inputAmountFormat(value, false, allowNegative);
        }}
        parser={(value) => {
          // 去掉 $ 和逗号
          return inputAmountFormat(value, true, allowNegative);
        }}
        onChange={(value) => {
          form.setFieldsValue({ [name]: value });
          form.validateFields([name]);
          if(typeof onChangeFn === 'function'){
            onChangeFn();
          }
        }}
        onBlur={() => {
          if(typeof onBlurFn === 'function'){
            onBlurFn();
          }
        }}
      />
    </Form.Item>
  )
}


const interestRateFormat = (amount, flag = false, allowNegative = true) => {
  let value = String(amount ?? '');
  if (!value) return '';

  // 特殊输入处理："-", "-.", ".", "0."
  if (/^-?$/.test(value)) return allowNegative ? value : '';
  if (/^-?\.$/.test(value)) return allowNegative ? value.replace('.', '0.') : '0.';
  if (/^\.$/.test(value)) return '0.';

  // 去掉无效字符
  value = allowNegative ? value.replace(/(?!^-)[^\d.]/g, '') : value.replace(/[^\d.]/g, '');

  // 判断负数
  let isNegative = allowNegative && value.startsWith('-');
  if (isNegative) value = value.slice(1);

  // 拆分整数和小数
  let [intPart, decPart] = value.split('.');

  // 负零处理
  if (isNegative && Number(value) === 0) isNegative = false;

  // flag = true → 返回纯数字（可带负号）
  if (flag) return (isNegative ? '-' : '') + value;

  // 千分位处理
  // intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return (isNegative ? '-' : '') + (decPart !== undefined ? `${intPart}.${decPart.slice(0, 2)}` : intPart);
};

// 负数金额显示格式化
const amountToDollarBracketFn = (text) => {
  if (text === 0 || text === null || text === undefined || text === '') return " ";

  const isNegative = Number(text) < 0;
  const absValue = Math.abs(Number(text));

  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(absValue);

  return isNegative ? `(${formatted})` : formatted;
};



const interestRateDoc = ({
  name = 'interestRate',
  label = 'Interest Rate',
  form,
  disabled = false,
  allowNegative = false,
  onChangeFn,
  isNoRequired = false,
  validator,
  onBlurFn
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={[
        { required: !isNoRequired, message: `${label} is required!`},
        {
          validator: validator || ((_, value, callback) => {
            if(value === 0){
              callback('Please enter an integer greater than 0!')
            } else {
              callback()
            }
          }), 
        },
      ]}
    >
      <InputNumber
        disabled={disabled}
        style={{ width: '100%' }}
        controls={false}
        suffix="%"
        placeholder={`Enter ${label}`}
        formatter={(value) => {
          if (value === undefined || value === null) return '';
          return interestRateFormat(value, false, allowNegative);
        }}
        parser={(value) => {
          return interestRateFormat(value, true, allowNegative);
        }}
        onChange={(value) => {
          form.setFieldsValue({ [name]: value });
          form.validateFields([name]);
          if(typeof onChangeFn === 'function'){
            onChangeFn();
          }
        }}
        onBlur={() => {
          if(typeof onBlurFn === 'function'){
            onBlurFn();
          }
        }}
      />
    </Form.Item>
  )
}

// 列表处理函数
const handleColunmItemFn = (item) => {
  const isTooltipFlagFn = (text) => {
    return (
      <Tooltip title={text}>
        <div
          style={{
            cursor: 'pointer',
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: item.isTooltipFlag
          }}
        >
          {text}
        </div>
      </Tooltip>
    )
  }
  const isWrapFlagFn = (text) => {
    return (
      <div
        style={{
          cursor: 'pointer',
          whiteSpace: "wrap",
          maxWidth: item.isWrapFlag
        }}
      >
        {text}
      </div>
    )
  }
  // %格式化处理
  const isPercentFlagFn = (text) => {
  if (text === null || text === undefined || text === '') return '-';
  const num = Number(text);
  if (!isFinite(num)) return '-';
  return `${num.toFixed(2)}%`;
};
  let temp = {};
  switch (true) {
    case item.dataIndex === "#":
      temp = {
        title: "#",
        key: "#",
        dataIndex: "#",
        hidden: item.hidden || false,
        align: item.align || "center",
        width: item.width || 100,
        render: item.render || ((text, record, index) => record[item.indexKey || '#'] || index + 1),
      };
      break;
    case item.titleType === "Input":
      temp = {
        title: () => (
          <div>
            <div>{item.title}</div>
            <div>
              <Input
                placeholder={item?.placeholder ? item.placeholder : `Search ${item.title}`}
                {...(Object.prototype.hasOwnProperty.call(item, 'filterValue') && {
                  value: item.filterValue ?? '',
                })}
                onClick={(e) => e.stopPropagation()}
                onChange={item.onChange}
                onKeyDown={item.onChange}
              />
            </div>
          </div>
        ),
        dataIndex: item.dataIndex,
        key: item.dataIndex,
        hidden: item.hidden || false,
        align: item.align || "center",
        width: item.width || 100,
        sorter: item.isSorter,
        className: item.className || "custom-sort-header",
        onCell: item.onCell,
        render:
          item.render ||
          ((text) => {
            if (item.isAmountFlag) {
              return amountToDollarFn(text)
            }else if (item.isBracketAmountFlag) {
              return (text)
            }else if (item.isTooltipFlag) {
              return isTooltipFlagFn(text)
            }else if (item.isWrapFlag) {
              return isWrapFlagFn(text)
            } else if (item.isPercentFlag) {  
              return isPercentFlagFn(text)
            }else if(item.isPercent) {
              return Number.isFinite(text) ? `${text}%` : null;
            } else {
              return text;
            }
          }),
      };
      break;
    case item.titleType === "Select":
      temp = {
        title: () => (
          <div>
            <div>{item.title}</div>
            <div>
              <Select
                showSearch
                optionFilterProp="label"
                placeholder={item.placeholder || `Select ${item.title}`}
                style={{ width: "100%" }}
                {...(Object.prototype.hasOwnProperty.call(item, 'filterValue') && {
                  value: item.filterValue,
                })}
                onChange={item.onChange}
                options={item.selectOptions || []}
                onClick={(e) => e.stopPropagation()}
                popupMatchSelectWidth={false}
                allowClear
              />
            </div>
          </div>
        ),
        dataIndex: item.dataIndex,
        key: item.dataIndex,
        hidden: item.hidden || false,
        align: item.align || "center",
        width: item.width || 100,
        sorter: item.isSorter,
        className: item.className || "custom-sort-header",
        onCell: item.onCell,
        render: item.render || ((text) => text),
      };
      break;

    case item.titleType === "DatePicker":
      temp = {
        title: () => (
          <div>
            <div>{item.title}</div>
            <DatePicker
              {...(Object.prototype.hasOwnProperty.call(item, 'filterValue') && {
                value: item.filterValue || null,
              })}
              onChange={item.onChange}
              format={item.format || "MM/DD/YYYY"}
              onClick={(e) => (e.preventDefault(), e.stopPropagation())}
              onFocus={(e) => e.preventDefault()}
              onBlur={(e) => e.preventDefault()}
            />
          </div>
        ),
        dataIndex: item.dataIndex,
        key: item.dataIndex,
        hidden: item.hidden || false,
        align: item.align || "center",
        width: item.width || 120,
        sorter: item.isSorter,
        className: item.className || "custom-sort-header",
        onCell: item.onCell,
        render:
          item.render || 
          ((text) => {
            if (item.isArrayDate) {
              return text && moment([text[0], text[1] - 1, text[2]]).format('MM/DD/YYYY') || ""
            } else {
              return text && moment(text).format(item.format || "MM/DD/YYYY") || ""
            }
          })
      };
      break;
    case item.titleType === "RangePicker":
      temp = {
        title: () => (
          <div>
            <div>{item.title}</div>
            <DatePicker.RangePicker
              {...(Object.prototype.hasOwnProperty.call(item, 'filterValue') && {
                value: item.filterValue || null,
              })}
              allowEmpty={item.allowEmpty || [true, true]}
              onChange={item.onChange}
              format={item.format || "MM/DD/YYYY"}
              onClick={(e) => (e.preventDefault(), e.stopPropagation())}
              onFocus={(e) => e.preventDefault()}
              onBlur={(e) => e.preventDefault()}
            />
          </div>
        ),
        dataIndex: item.dataIndex,
        key: item.dataIndex,
        hidden: item.hidden || false,
        align: item.align || "center",
        width: item.width || 150,
        sorter: item.isSorter,
        className: item.className || "custom-sort-header",
        onCell: item.onCell,
        render:
          item.render ||
          ((text) => {
            if (item.isArrayDate) {
              return text && moment([text[0], text[1] - 1, text[2]]).format('MM/DD/YYYY') || ""
            } else {
              return text && moment(text).format(item.format || "MM/DD/YYYY") || ""
            }
          })
      };
      break;
    default:
      temp = {
        hidden: item.hidden || false,
        align: item.align || "center",
        width: item.width || 120,
        sorter: item.isSorter,
        className: item.className || "custom-sort-header",
        render:
        item.render || ((text) => {
          if (item.isAmountFlag) {
            return amountToDollarFn(text)
          } else if (item.isBracketAmountFlag) {
            return amountToDollarBracketFn(text)
          } else if (item.isTooltipFlag) {
            return isTooltipFlagFn(text)
          } else if (item.isWrapFlag) {
            return isWrapFlagFn(text)
          }else if (item.isPercentFlag) {  
          return isPercentFlagFn(text)
        } else if(item.isPercent) {
            return Number.isFinite(text) ? `${text}%` : null;
          } else if(item.isArrayDate){
            return text && moment([text[0], text[1] - 1, text[2]]).format('MM/DD/YYYY') || ""
          } else {
            return text;
          }
        }),
        ...item,
      };
      break;
  }
  temp.onCell = (record, index) => {
    const cellProps = item.onCell?.(record, index) || {};
    return {
      ...cellProps,
      style: {
        overflowWrap: "anywhere",
        ...cellProps.style,
      },
    };
  };
  return temp;
};

const handleColunmFn = (arr, pagination) => {
  const isArrFlag = Array.isArray(arr);
  if (!isArrFlag) return [];
  return arr.map((item) => handleColunmItemFn(item, pagination));
};

let activeTablePageSize;

const setActiveTablePageSize = (pageSize) => {
  activeTablePageSize = pageSize;
};

const tableFilterFn = ({
  event,
  type,
  key,
  setTableHead,
  getTableListFn,
  pageSize = 25
}) => {
  const currentPageSize = event?.tablePageSize || activeTablePageSize || pageSize;
  switch (type) {
    case 'Input':
      if (event?.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        setTableHead((prev) => {
          const updatedTableHeadRole = { ...prev, [key]: event?.target?.value || undefined };
          getTableListFn(1, currentPageSize, updatedTableHeadRole);
          return updatedTableHeadRole;
        });
      }else{
        setTableHead((prev) => {
          const updatedTableHeadRole = { ...prev, [key]: event?.target?.value || undefined };
          return updatedTableHeadRole;
        });
      }
      break;
    case 'Select':
      setTableHead((prev) => {
        const updatedTableHead = { ...prev, [key]: event || undefined };
        getTableListFn(1, currentPageSize, updatedTableHead);
        return updatedTableHead;
      });
      break;
    case 'DatePicker':
      setTableHead((prev) => {
        const updatedTableHead = { ...prev, [key]: event?.valueOf() || undefined };
        getTableListFn(1, currentPageSize, updatedTableHead);
        return updatedTableHead;
      });
      break;
    case 'DatePickerFormat':
      setTableHead((prev) => {
        const updatedTableHead = { ...prev, [key]: event && moment(event?.valueOf())?.format('YYYY-MM-DD') || undefined };
        getTableListFn(1, currentPageSize, updatedTableHead);
        return updatedTableHead;
      });
      break;
    case 'RangePicker':
      setTableHead((prev) => {
        const updatedTableHead = { ...prev, [key[0]]: event?.[0]?.valueOf() || undefined, [key[1]]: event?.[1]?.valueOf() || undefined };
        getTableListFn(1, currentPageSize, updatedTableHead);
        return updatedTableHead;
      });
      break;
    default:
      break;
  }
};

// 处理menu数据
const handleMenuFn = (menuList) => {
  const obj = [];
  menuList.forEach(item => {
    const urls = (item?.childNode || []).filter(v => v.sfyxz === 1);
    if (urls.length) {
      obj.push({ ...item, urls })
    }
  });
  return obj
}
const resultMenuFn = (pathObj) => {
  return pathObj.map(item => {
    return {
      key: item.menuUrl,
      label: item.menuName,
      menuIcon: item.menuIcon,
      children: (item.childNode || []).filter(v => v.sfyxz === 1).map(v => ({
        ...v,
        key: v.menuUrl,
        label: v.menuName,
      }))
    }
  })
}

const initLoginDataFn = (data, flag) => {
  localStorage.clear();
  const { accountInfo, token, encryptPassword } = data;
  localStorage.setItem("user", JSON.stringify(accountInfo.account));
  localStorage.setItem("createBy", accountInfo.account.email);
  localStorage.setItem("accountId", accountInfo.account.accountId);
  localStorage.setItem("tokenPC", token);

  const temp = handleMenuFn(accountInfo.menuList || []) || [];
  const menuList = resultMenuFn(temp) || [];
  localStorage.setItem("menuList", JSON.stringify(menuList));
  useCommonStore.getState().setButtonListAuthority(accountInfo?.buttonMap || {})
  if(flag){
    useCommonStore.getState().setSideMenuRefreshKey(+new Date())
  } else {
    if(encryptPassword) localStorage.setItem("encryptPassword", encryptPassword);
    window.location.href = `${window.location.origin}#/home/index`;
  }
};

 const getBlobFn = (data) => {
  const a = document.createElement('a');
  document.body.appendChild(a)
  a.style.display = 'none'
  // 使用获取到的blob对象创建的url
  // 去掉 Base64 前缀（如果有的话，例如 "data:application/pdf;base64,"）
  const base64HeaderMatch = data.url.match(/^data:(.*?);base64,/);
  let cleanBase64 = data.url;
  if (base64HeaderMatch) {
      cleanBase64 = data.url.replace(base64HeaderMatch[0], '');
  }

  // 将 Base64 转换为二进制数据
  const byteCharacters = atob(cleanBase64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const url = window.URL.createObjectURL(new Blob([byteArray]),{type: 'application/pdf'});
  
  a.href = url;
  // 指定下载的文件名
  a.download = data.name;
  a.click();
  document.body.removeChild(a)
  // 移除blob对象的url
  window.URL.revokeObjectURL(url);
 }

 const getBlobExcelFn = async({blob, name, suffix = 'xlsx', type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}) => {
    const url = window.URL.createObjectURL(new Blob([blob]),{type});
    const a = document.createElement('a');
    document.body.appendChild(a)
    a.style.display = 'none'
    a.href = url;
    // 指定下载的文件名
    a.download = `${name}_${moment(new Date()).format("MM-DD-YYYY")}.${suffix}`;
    a.click();
    document.body.removeChild(a)
    // 移除blob对象的url
    window.URL.revokeObjectURL(url);
 }

 const modalFailedFn = (response, fn) => {
   if(['4', '6', '7'].includes(response?.code) || !response?.code) return
   let modal = Modal.confirm({
     className: 'commonModal',
     title: 'Failed',
     icon: <ExclamationCircleOutlined />,
     content: response?.msg || response?.data,
     footer: [
       <div className="footerBtn">
         <Button className="OKBtn" type="primary" onClick={ () => (modal.destroy(), fn && fn())}>
           OK
         </Button>
       </div>
     ],
     style: {
       top: '40%',
     },
   })
 }

  const iconDocFn = ({ iconKey = "add", width = 16, height = 16, marginRight = 0, imageStyle }) => {
   return (
    <img 
      src={commonIcon[iconKey]} 
      alt={null} 
      style={{ width, height, marginRight, ...imageStyle }} 
    />
   )
  }
  
  const btnDocFn = ({ name = "New", className = "btnNew", btnFn = () =>{}, noShowIcon = false, loading = false, disabled = false, extraDoc = null }, iconData = {}, btnStyle) => {
   return (
    <Button className={className} style={btnStyle} onClick={btnFn} loading={loading} disabled={disabled}>
      {!noShowIcon && iconDocFn(iconData) || null}
      {name}
      {extraDoc}
    </Button>
   )
  }


  const btnAuthorityFlag = (authKey) => {
    const path = window.location.hash?.split("?")[0]?.split('/')?.[2]
    const compatiblePathMatch = {
      'CreditCheck': 'creditCheck',
      'ApprovalSummaryMonthlyTableDetail': 'ApprovalSummary',
      'ApprovalSummaryUtilTableDetail': 'ApprovalSummary',
      'ApprovalSummaryPendingTableDetail': 'ApprovalSummary',
      'MaintenanceContractorTableDetail': 'ApprovalSummary',
      'GardenerAPTableDetail': 'ApprovalSummary',
      'MaintenanceMonthlyWorkerDetail': 'ApprovalSummary',
      'MaintenanceMonthlyWorkerSubDetail': 'ApprovalSummary',
      'BusinessLicenseTableDetail': 'ApprovalSummary',
      'MajorProjectTableDetail': 'ApprovalSummary',
      'MaterialListAPDetail': 'ApprovalSummary',
      'InsuranceDetail': 'ApprovalSummary',
      'CheckApprovalDetail': 'CheckApproval',
      'CheckApprovalUtilPaymentDetail': 'CheckApproval',
      'CheckApprovalMaintenanceDetail': 'CheckApproval',
      'CheckApprovalMainContractorDetail': 'CheckApproval',
      'CAGardenerAPDetail': 'CheckApproval',
      'CheckApprovalMonthlyWorkerDetail': 'CheckApproval',
      'CheckApprovalMonthlyWorkerSubDetail': 'CheckApproval',
      'CheckApprovalBusinessLicenseDetail': 'CheckApproval',
      'CheckMajorProjectTableDetail': 'CheckApproval',
      'CAMaterialListAPDetail': 'CheckApproval',
      'CAInsuranceDetail': 'CheckApproval',
      'MajorProjectEdit': 'MajorProject',
      'ViewLoan': 'Mortgage',
      'InsurancePage':'InsuranceSummary',
      'InsuranceEnterPaymentPage':'InsuranceSummary',
      'GardenerAPMaintenance': 'GardenerAP',
    }
    const pathKey = compatiblePathMatch[path] || path
    const btnList = useCommonStore.getState().buttonListAuthority[pathKey] || []
    return btnList.includes(authKey);
  };

  const BtnAuthorityFn = ({authKey, children}) => {
    const flag = btnAuthorityFlag(authKey)
    if (!flag) {
      return null; // 没权限就不渲染
    }
    return <>{children}</>;
  };

  const setAuthorityFn = async(list) => {
    const promises = list.map(params => 
      http.post(api.getSaveMenu, params)
    );
    Promise.all(promises).then(res=>{
      console.log(res,'===return ');
    })
  }

  const closeBrowserTabFn = () => {
    // undefined = 正常状态
    // oldTabClose = 跳转的页面被关闭
    // newTabClose = 新打开页面被关闭
    const closeBrowserTabFlag = localStorage.getItem('closeBrowserTabFlag')
    if(closeBrowserTabFlag === 'oldTabClose'){
      localStorage.removeItem('closeBrowserTabFlag')
      window.location.href = `${window.location.origin}#/AccountPayable/CheckApproval`;
    }else{
      localStorage.setItem("closeBrowserTabFlag", 'newTabClose');
      const w = window.open('', '_self');
      w.close();
    }
  }

  // zip校验
const zipValidator = (_, value) => {
  // if (!value) return Promise.resolve();
    const v = (value || "").trim(); 

  if (!v) {
    return Promise.resolve(); // 空 or 空格都放行
  }
  const zipRegex = /^\d{5}(-?\d{4})?$/;
  if (!zipRegex.test(value)) {
    return Promise.reject(
      new Error(
        "Please enter a valid US Zip Code (12345 or 12345-6789)"
      )
    );
  }
  return Promise.resolve();
};
// 电话校验
// 去掉非数字
const normalizePhone = (value) => {
  return String(value ?? "").replace(/\D/g, "");
};
const usPhoneValidator = (_, value) => {
  const raw = String(value ?? "").trim();
  if (!raw) return Promise.resolve(); // 非必填

  const digits = normalizePhone(raw);
  // 美国号码规则：
  // 10位，或 11位且以1开头
  if (
    digits.length === 10 ||
    (digits.length === 11 && digits.startsWith("1"))
  ) {
    return Promise.resolve();
  }

  return Promise.reject(
    new Error("Please enter a valid US phone number")
  );
};

/**
 * 将指定字段转换为字符串
 * @param {Object} data - 原始数据对象
 * @param {Array} fields - 需要转换为字符串的字段数组
 * @returns {Object} 转换后的新对象
 */
const convertFieldsToString = (data, fields) => {
  if (!data || typeof data !== 'object') return data;
  if (!Array.isArray(fields) || fields.length === 0) return data;
  
  const result = { ...data };
  fields.forEach(field => {
    if (result[field] !== undefined && result[field] !== null) {
      result[field] = String(result[field]);
    }
  });
  return result;
};

/**
 * 让表头筛选框不触发浏览器的地址/密码自动填充
 * @param {HTMLElement} root 监听范围,默认整个页面
 * @param {string} selector 要处理的输入框选择器,默认只处理表头里的
 * @returns {Function} 清理函数,调用后停止监听
 */
const disableAutofill = (
  root = document.body,
  selector = ".ant-table-thead input",
) => {
  if (!root || typeof MutationObserver === "undefined") return () => {};

  let scheduled = false;
  const apply = () => {
    scheduled = false;
    root.querySelectorAll(selector).forEach((el) => {
      if (el.getAttribute("autocomplete") !== "new-password") {
        el.setAttribute("autocomplete", "new-password");
      }
    });
  };
  // 表头会随数据、分页、列配置重新渲染,用 rAF 合并成每帧最多处理一次
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  };

  apply();
  const observer = new MutationObserver(schedule);
  observer.observe(root, { childList: true, subtree: true });
  return () => observer.disconnect();
};

export default {
  uploadFiles,
  uploadFilesNew,
  amountToDollarFn,
  amountToDollarBracketFn,
  inputAmountFormat,
  formInputNumberDoc,
  formInputNumberOptionalDoc,
  interestRateDoc,
  handleColunmFn,
  setActiveTablePageSize,
  tableFilterFn,
  initLoginDataFn,
  getBlobFn,
  getBlobExcelFn,
  modalFailedFn,
  iconDocFn,
  btnDocFn,
  btnAuthorityFlag,
  BtnAuthorityFn,
  setAuthorityFn,
  closeBrowserTabFn,
  zipValidator,
  usPhoneValidator,
  convertFieldsToString, 
  disableAutofill, 
};
